export const title = (title) => {
  switch (title) {
    case 'avg_price':
      return 'Harga Rata-Rata';
      break;
    case 'min_price':
      return 'Harga Minimum';
      break;
    case 'max_price':
      return 'Harga Maximum';
      break;
  }
};

export const LOGIN_PAGE_DESC = `Market Auction Price (MAP) adalah aplikasi yang <br/> menyediakan informasi harga pasaran mobil lelang <br/> terlengkap di Indonesia. Buatlah keputusan yang tepat <br/> dan menguntungkan, karena semua informasi harga <br/> pasaran mobil yang mau Anda beli atau jual ada disini.`;
